// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PatientFinderPatientResponseAddress } from './patientFinderPatientResponseAddress.js';
import type { PatientFinderPatientResponseIdentifier } from './patientFinderPatientResponseIdentifier.js';
import type { PatientFinderPatientResponseName } from './patientFinderPatientResponseName.js';
import type { PatientFinderPatientResponsePhone } from './patientFinderPatientResponsePhone.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientFinderResponseMemberData {
    'aboveThreshold'?: boolean;
    'accountId'?: string;
    'addresses'?: Array<PatientFinderPatientResponseAddress>;
    'clientId'?: string;
    'deceasedFlag'?: string;
    'dob'?: string;
    'echLid'?: string;
    'emailAddress'?: string;
    'enterprisePersonNumber'?: string;
    'ethnicDetails'?: string;
    'ethnicGroup'?: string;
    'firstName'?: string;
    'gender'?: string;
    'hospitalGroup'?: string;
    'identifiers'?: Array<PatientFinderPatientResponseIdentifier>;
    'lastName'?: string;
    'maritalStatus'?: string;
    'matchWeight'?: string;
    'middleInitial'?: string;
    'middleName'?: string;
    'mrn'?: string;
    'mrnIssuer'?: string;
    'names'?: Array<PatientFinderPatientResponseName>;
    'nameSuffix'?: string;
    'passportId'?: string;
    'phones'?: Array<PatientFinderPatientResponsePhone>;
    'rank'?: string;
    'requestId'?: string;
    'sourceId'?: string;
    'tradingPartnerId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientFinderResponseMemberData>> = [
        {
            "name":     "aboveThreshold",
            "baseName": "aboveThreshold",
            "type":     "boolean"
        },
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "string"
        },
        {
            "name":     "addresses",
            "baseName": "addresses",
            "type":     "Array<PatientFinderPatientResponseAddress>"
        },
        {
            "name":     "clientId",
            "baseName": "clientId",
            "type":     "string"
        },
        {
            "name":     "deceasedFlag",
            "baseName": "deceasedFlag",
            "type":     "string"
        },
        {
            "name":     "dob",
            "baseName": "dob",
            "type":     "string"
        },
        {
            "name":     "echLid",
            "baseName": "echLid",
            "type":     "string"
        },
        {
            "name":     "emailAddress",
            "baseName": "emailAddress",
            "type":     "string"
        },
        {
            "name":     "enterprisePersonNumber",
            "baseName": "enterprisePersonNumber",
            "type":     "string"
        },
        {
            "name":     "ethnicDetails",
            "baseName": "ethnicDetails",
            "type":     "string"
        },
        {
            "name":     "ethnicGroup",
            "baseName": "ethnicGroup",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "string"
        },
        {
            "name":     "hospitalGroup",
            "baseName": "hospitalGroup",
            "type":     "string"
        },
        {
            "name":     "identifiers",
            "baseName": "identifiers",
            "type":     "Array<PatientFinderPatientResponseIdentifier>"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "maritalStatus",
            "baseName": "maritalStatus",
            "type":     "string"
        },
        {
            "name":     "matchWeight",
            "baseName": "matchWeight",
            "type":     "string"
        },
        {
            "name":     "middleInitial",
            "baseName": "middleInitial",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "mrn",
            "baseName": "mrn",
            "type":     "string"
        },
        {
            "name":     "mrnIssuer",
            "baseName": "mrnIssuer",
            "type":     "string"
        },
        {
            "name":     "names",
            "baseName": "names",
            "type":     "Array<PatientFinderPatientResponseName>"
        },
        {
            "name":     "nameSuffix",
            "baseName": "nameSuffix",
            "type":     "string"
        },
        {
            "name":     "passportId",
            "baseName": "passportId",
            "type":     "string"
        },
        {
            "name":     "phones",
            "baseName": "phones",
            "type":     "Array<PatientFinderPatientResponsePhone>"
        },
        {
            "name":     "rank",
            "baseName": "rank",
            "type":     "string"
        },
        {
            "name":     "requestId",
            "baseName": "requestId",
            "type":     "string"
        },
        {
            "name":     "sourceId",
            "baseName": "sourceId",
            "type":     "string"
        },
        {
            "name":     "tradingPartnerId",
            "baseName": "tradingPartnerId",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PatientFinderResponseMemberData.attributeTypeMap;
    }
}
